<template>
  <div id="app">
    <glheader active="index"></glheader>

    <div class="container">
      <div class="page index">
        <div class="part">
          <img src="../../assets/pic1.png" alt="股励新财富" />
        </div>
      </div>
      <div class="page about">
        <div class="part">
          <img src="../../assets/pic2.png" class="bg" />

          <img src="../../assets/mail.png" class="mail" alt="股励邮箱" />
          <div class="about">
            <h1>关于股励</h1>
            <p>政邦股励、是由阿里系、浙商系、赣商系股东发起成立的服务平台。我们怀抱为创业者创造福利的初心，提供专业性极强的股权投资、股权融资、股权激励、股权架构等专题服务。其中2019年设立的子品牌股励新财富聚焦于科创版、独角兽股期权投融资交易，为高净值用户提供了优质的全新财富管理路径。「股励新财富、股权创造财富」，让我们用专业的能力和独特的视角交出属于未来财富的新答卷。</p>
          </div>
        </div>
      </div>
      <div class="page">
        <div class="part3">
          <img src="../../assets/insist.png" class="insist" alt="股励坚持" />
          <div class="list">
            <img src="../../assets/chuxin.png" class="chuxin" alt="初心" />
            <img src="../../assets/xinnian.png" class="xinnian" alt="信念" />
            <img src="../../assets/zhuanye.png" class="zhuanye" alt="专业" />
          </div>
          <img src="../../assets/you.png" class="bottom" />
        </div>
      </div>
    </div>

    <glfooter></glfooter>
  </div>
</template>

<script>
import glheader from '../../components/glheader.vue'
import glfooter from '../../components/glfooter.vue'

export default {
  components: {
    glheader,
    glfooter
  },
  data() {
    return {}
  },
  methods: {}
}
</script>

<style lang="postcss">
.container {
  margin-top: 90px;
}
.part {
  position: relative;
}
.part img {
  width: 100%;
}
.part img.mail {
  width: 30%;
  position: absolute;
  top: 30%;
  right: 20%;
}
.part .about {
  position: absolute;
  left: 20%;
  top: 50%;
  width: 30%;
}
.about h1 {
  text-align: center;
  font-size: 28px;
  color: #333333;
  font-weight: bold;
  line-height: 60px;
}
.about p {
  text-align: justify;
  font-size: 16px;
  color: #333333;
  line-height: 24px;
}
.part3 {
  width: 100%;
  height: 64%;
}
.insist {
  display: block;
  width: 26.5%;
  margin: 10% auto 10%;
}
.list {
  width: 80%;
  display: flex;
  justify-content: space-around;
  align-items: flex-start;
  margin: auto;
}
.chuxin {
  display: inline-block;
  width: 104px;
}
.xinnian {
  display: inline-block;
  width: 103px;
}
.zhuanye {
  display: inline-block;
  width: 150px;
}
.bottom {
  width: 100%;
  position: relative;
  top: -20px;
}

/* pad style */
@media (max-width: 1200px) {
  .container {
    margin-top: 56px;
  }
  .about .bg {
    display: none;
  }
  .about .part {
    background-image: url(../../assets/pic2.png);
    background-size: cover;
    padding: 24px 0;
    min-height: 400px;
  }
  .part img.mail {
    position: static;
    display: block;
    width: 40%;
    margin: 40px auto;
  }

  .part .about {
    width: 60%;
    position: static;
    margin: 40px auto;
  }
  .about h1 {
    font-size: 18px;
  }
  .insist {
    width: 40%;
    margin: 40px auto 60px;
  }
  .chuxin {
    width: 12%;
  }
  .xinnian {
    width: 12%;
  }
  .zhuanye {
    width: 17%;
  }
}

/* mobile style */
@media (max-width: 580px) {
  .part img.mail {
    position: static;
    width: 60%;
    left: 0;
    right: 0;
    top: 24px;
    margin: auto;
  }

  .part .about {
    position: static;
    left: 0;
    right: 0;
    margin: 40px auto;
    top: 70px;
    width: 80%;
    height: 50%;
    overflow-y: auto;
  }
  .insist {
    width: 60%;
  }
  .chuxin {
    width: 20%;
  }
  .xinnian {
    width: 20%;
  }
  .zhuanye {
    width: 30%;
  }
}
</style>
